import type { BillingAddressFormState } from "@/lib/invoiceBillingAddress";

export interface InvoiceBillingAddressFieldsProps {
  value: BillingAddressFormState;
  onChange: (value: BillingAddressFormState) => void;
  disabled?: boolean;
}

export function InvoiceBillingAddressFields({
  value,
  onChange,
  disabled = false,
}: InvoiceBillingAddressFieldsProps) {
  function update<K extends keyof BillingAddressFormState>(key: K, next: BillingAddressFormState[K]) {
    onChange({ ...value, [key]: next });
  }

  return (
    <div className="space-y-3 rounded-lg border border-separator bg-fill-tertiary/20 p-3">
      <label className="flex cursor-pointer items-center gap-2 text-sm font-medium text-label">
        <input
          type="checkbox"
          className="eh-checkbox"
          checked={value.override}
          disabled={disabled}
          onChange={(e) => update("override", e.target.checked)}
        />
        Abweichende Rechnungsanschrift
      </label>

      {value.override ? (
        <div className="grid gap-2 sm:grid-cols-2">
          <label className="block text-sm sm:col-span-2">
            <span className="mb-1 block text-label-secondary">Firma (optional)</span>
            <input
              type="text"
              className="eh-input w-full"
              value={value.company_name}
              disabled={disabled}
              onChange={(e) => update("company_name", e.target.value)}
            />
          </label>
          <label className="block text-sm sm:col-span-2">
            <span className="mb-1 block text-label-secondary">Empfänger</span>
            <input
              type="text"
              className="eh-input w-full"
              value={value.name}
              disabled={disabled}
              onChange={(e) => update("name", e.target.value)}
            />
          </label>
          <label className="block text-sm sm:col-span-2">
            <span className="mb-1 block text-label-secondary">Straße</span>
            <input
              type="text"
              className="eh-input w-full"
              value={value.street}
              disabled={disabled}
              onChange={(e) => update("street", e.target.value)}
            />
          </label>
          <label className="block text-sm">
            <span className="mb-1 block text-label-secondary">PLZ</span>
            <input
              type="text"
              className="eh-input w-full"
              value={value.postal_code}
              disabled={disabled}
              onChange={(e) => update("postal_code", e.target.value)}
            />
          </label>
          <label className="block text-sm">
            <span className="mb-1 block text-label-secondary">Ort</span>
            <input
              type="text"
              className="eh-input w-full"
              value={value.city}
              disabled={disabled}
              onChange={(e) => update("city", e.target.value)}
            />
          </label>
        </div>
      ) : null}
    </div>
  );
}
